<template>
  <Layout>
    <div class="error-page-wrapper d-flex align-items-center justify-content-center">
      
      <!-- Décorations de fond (optionnel) -->
      <div class="bg-decoration blur-1"></div>
      <div class="bg-decoration blur-2"></div>

      <div class="error-content text-center px-3">
        
        <!-- Grand Code Erreur -->
        <div class="error-code-container mb-2">
          <h1 class="error-code-display">404</h1>
          <div class="error-code-overlay">404</div>
        </div>

        <!-- Message Principal -->
        <div class="message-box">
          <h2 class="font-weight-bold text-dark mb-3">Page introuvable</h2>
          <p class="text-muted mb-5 mx-auto" style="max-width: 450px;">
            Désolé, nous ne parvenons pas à trouver la page que vous recherchez. 
            Vérifiez l'URL ou retournez à votre tableau de bord.
          </p>

          <!-- Bouton Indigo -->
          <div class="d-flex justify-content-center gap-3">
            <b-button 
              variant="primary" 
              href="/dashboard" 
              class="btn-indigo-pill px-5 py-3 shadow-lg"
            >
              <i class="fas fa-home me-2"></i> RETOUR AU TABLEAU DE BORD
            </b-button>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/LayoutScreen.vue";

export default {
  name: "NotFoundPage",
  components: { Layout }
};
</script>

<style scoped>
.error-page-wrapper {
  min-height: 85vh; /* Ajusté pour tenir compte du Layout header */
  position: relative;
  overflow: hidden;
  background-color: #f8f9fb;
}

/* --- Typographie 404 --- */
.error-code-container {
  position: relative;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-code-display {
  font-size: 10rem;
  font-weight: 900;
  color: #eef2ff; /* Indigo très clair */
  margin: 0;
  letter-spacing: -5px;
}

.error-code-overlay {
  position: absolute;
  font-size: 5rem;
  font-weight: 800;
  color: #4f46e5; /* Indigo Principal */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  opacity: 0.15;
}

/* --- Message & Box --- */
.message-box h2 {
  font-size: 2rem;
  letter-spacing: -0.5px;
}

.text-muted {
  font-size: 1.1rem;
  line-height: 1.6;
}

/* --- Bouton Indigo --- */
.btn-indigo-pill {
  background-color: #4f46e5;
  border: none;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.btn-indigo-pill:hover {
  background-color: #4338ca;
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(79, 70, 229, 0.3) !important;
}

/* --- Décorations --- */
.bg-decoration {
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}

.blur-1 {
  width: 300px;
  height: 300px;
  background: rgba(79, 70, 229, 0.05);
  top: -100px;
  right: -50px;
  filter: blur(80px);
}

.blur-2 {
  width: 250px;
  height: 250px;
  background: rgba(99, 102, 241, 0.05);
  bottom: -50px;
  left: -50px;
  filter: blur(60px);
}

.text-indigo { color: #4f46e5; }
.text-silver { color: #94a3b8; }

@media (max-width: 576px) {
  .error-code-display { font-size: 7rem; }
  .error-code-overlay { font-size: 3.5rem; }
  .btn-indigo-pill { width: 100%; }
}
</style>